/**
 * Atendente IA & SDR — wrapper inline pra Configuração · IA (OpenSpec
 * unify-ia-settings-and-retire-legacy-sdr Fase 1).
 *
 * Substitui a tab legacy "SDR (Funil IA)" por uma tab que combina
 * AtendenteIaBuilder (blocos do prompt do SDR Conversation Agent) +
 * SdrCamposTab (schema de campos a extrair pelo Field Extractor) numa
 * única UI com sidebar vertical interna (2 itens).
 *
 * As demais seções da spec — Playground end-to-end, Uso, Histórico,
 * assistente conversacional multi-turn — ficam pra Fase 2.
 */
import React, { useState } from 'react';
import { AtendenteIaBuilder } from '../../pages/IaConsole/AtendenteIaBuilder';
import SdrCamposTab from '../../pages/IaConsole/SdrCamposTab';

type InlineSection = 'atendente' | 'sdr_campos';

interface Props {
  canEdit: boolean;
}

const SECTIONS: Array<{ id: InlineSection; label: string; icon: string }> = [
  { id: 'atendente', label: 'Atendente IA', icon: '🤖' },
  { id: 'sdr_campos', label: 'SDR · Campos', icon: '📋' },
];

export const AtendenteIaInlineTab: React.FC<Props> = ({ canEdit }) => {
  const [active, setActive] = useState<InlineSection>('atendente');

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '220px 1fr',
        gap: 16,
        marginTop: 8,
        minHeight: 520,
      }}
    >
      <aside
        style={{
          background: '#fff',
          border: '1px solid #e2e8f0',
          borderRadius: 8,
          padding: 12,
          height: 'fit-content',
        }}
      >
        <div
          style={{
            fontSize: 11,
            color: '#64748b',
            fontWeight: 700,
            letterSpacing: 0.5,
            marginBottom: 10,
            paddingLeft: 8,
          }}
        >
          ATENDENTE IA &amp; SDR
        </div>
        {SECTIONS.map((s) => {
          const isActive = active === s.id;
          return (
            <button
              key={s.id}
              type="button"
              onClick={() => setActive(s.id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                width: '100%',
                padding: '10px 12px',
                marginBottom: 4,
                background: isActive ? '#eef2ff' : 'transparent',
                color: isActive ? '#4338ca' : '#1f2937',
                border: '1px solid',
                borderColor: isActive ? '#c7d2fe' : 'transparent',
                borderRadius: 6,
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: isActive ? 600 : 500,
                textAlign: 'left',
              }}
            >
              <span aria-hidden style={{ fontSize: 16 }}>
                {s.icon}
              </span>
              <span style={{ flex: 1 }}>{s.label}</span>
            </button>
          );
        })}
      </aside>

      <div style={{ minWidth: 0 }}>
        {active === 'atendente' && <AtendenteIaBuilder canEdit={canEdit} embeddedMode />}
        {active === 'sdr_campos' && <SdrCamposTab canEdit={canEdit} />}
      </div>
    </div>
  );
};

export default AtendenteIaInlineTab;
